import { postApiCcofPracticeIdPatientsSearch } from "@/lib/api-client/endpoints/ccof-patient/ccof-patient";
import { useTokenPagedInfiniteQuery } from "@/lib/query/useTokenPagedInfiniteQuery";
import { CcofPatientSearchResult } from "lib/api-types/schemas";
import { PAGE_SIZE } from "@/lib/query/constants";

async function fetchPatientPage(
  practiceId: string,
  query: string,
  nextToken?: string,
) {
  const res = await postApiCcofPracticeIdPatientsSearch(practiceId, {
    filter: { query },
    pageSize: PAGE_SIZE,
    nextToken,
  });

  return {
    items: res.data.items ?? [],
    nextToken: res.data.nextToken,
  };
}

export const patientSearchQueryKey = (practiceId: string, query: string) =>
  ["patients", "search", practiceId, query] as const;

export function usePatientSearch(practiceId: string, query: string) {
  return useTokenPagedInfiniteQuery<CcofPatientSearchResult>({
    queryKey: patientSearchQueryKey(practiceId, query),
    fetchPage: (nextToken?: string) =>
      fetchPatientPage(practiceId, query, nextToken),
    enabled: query.length > 0,
  });
}
